import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import AdminRouter from './AdminRouter';
import { PrivateRoute } from '@/shared/access';
import { PartnerRoute } from '@/shared/navigation';

const QuestionaryTestPage = React.lazy(() => import('@pages/Onboarding').then(module => ({ default: module.Onboarding })));
const Login = React.lazy(() => import('@pages/Login').then(module => ({ default: module.Login })));
const SignUp = React.lazy(() => import('@pages/Login').then(module => ({ default: module.SignUp })));
const SelectType = React.lazy(() => import('@pages/Login').then(module => ({ default: module.SelectType })));
const ForgotPassword = React.lazy(() => import('@pages/Login').then(module => ({ default: module.ForgotPassword })));
const GsoSchedulingWelcome = React.lazy(() =>
  import('@pages/GrowSelfOnboarding').then(module => ({ default: module.GsoSchedulingWelcome }))
);
const GsoSchedule = React.lazy(() => import('@pages/GrowSelfOnboarding').then(module => ({ default: module.GsoSchedule })));

const GsoInvoicingWelcome = React.lazy(() =>
  import('@pages/GrowSelfOnboarding').then(module => ({ default: module.GsoInvoicingWelcome }))
);

const GsoInvoice = React.lazy(() => import('@pages/GrowSelfOnboarding').then(module => ({ default: module.GsoInvoice })));
const GsoGenerate = React.lazy(() => import('@pages/gso/Generate').then(module => ({ default: module.GsoGenerate })));

export default function ApplicationRouter() {
  return (
    <Switch>
      <Route
        path="/gso/scheduling/welcome/:gsoId?"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <GsoSchedulingWelcome {...props} />
          </Suspense>
        )}
        key="/gso-scheduling-welcome"
      />
      <Route
        path="/gso/scheduling/:gsoId?"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <GsoSchedule {...props} />
          </Suspense>
        )}
        key="/gso-scheduling"
      />
      <Route
        path="/gso/invoicing/welcome/:gsoId?"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <GsoInvoicingWelcome {...props} />
          </Suspense>
        )}
        key="/gso-invoicing-welcome"
      />
      <Route
        path="/gso/invoicing/:gsoId?"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <GsoInvoice />
          </Suspense>
        )}
        key="/gso-invoicing"
      />

      <Route
        path="/gso/generate"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <GsoGenerate />
          </Suspense>
        )}
        key="/gso-generate"
      />

      <Route
        path="/login"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <SelectType {...props} />
          </Suspense>
        )}
        key="/select-type"
      />
      <Route
        path="/forgot-password/:identity"
        exact
        component={(props: any) => (
          <Suspense fallback={null}>
            <ForgotPassword {...props} />
          </Suspense>
        )}
        key="/forgot-password"
      />
      <Route
        path="/login/:identity?"
        component={(props: any) => (
          <Suspense fallback={null}>
            <Login {...props} />
          </Suspense>
        )}
        key="/login"
      />
      <Route
        path="/signup"
        component={(props: any) => (
          <Suspense fallback={null}>
            <SignUp {...props} />
          </Suspense>
        )}
        key="/signup"
      />
      <PartnerRoute
        path="/(p-)?:partnerId?/onboarding"
        component={() => (
          <Suspense fallback={null}>
            <QuestionaryTestPage />
          </Suspense>
        )}
        key="/questionary"
      />
      <PrivateRoute path="/" component={AdminRouter} />
    </Switch>
  );
}
